import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { AppState } from '../../../../store/index';
import { UtilsService } from '../../../services/api/utils.service';

import { SoledadUserService } from '../../../../shared/services/b2b/user.service';
import { isEmptyObject, isUndefined } from '../../../../shared/lib/helpers/utils';
import { detectChangesOnFinalize } from '../../custom-rxjs-operators/detect-changes-on-finalize.operator';

// Models
import { Note } from '../../../models/b2b/note';
import { User } from '../../../models/b2b/user';

// NgRx
import { ModalsService } from '../../../../shared/services/utils/modals.service';
import { EventsService } from '../../../../../app/shared/services/utils/events.service';
import { ToastData, ToastDataHelper } from '../../../../../app/shared/models/b2b/toastData';

@Component({
    selector: 'app-item-deliverynote-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './item-deliverynote-list.component.html'
})
export class ItemDeliveryNoteListComponent {
    @Input() item: Note;

    loading: boolean;
    user: User;

    constructor(
        private store: Store<AppState>,
        private utilsService: UtilsService,
        public usersService: SoledadUserService,
        private eventsService: EventsService,
        private translatesService: TranslateService,
        private modalsService: ModalsService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.subscribeUserData();
    }

    subscribeUserData(): void {
        this.store
            .select((state) => state.user.data)
            .subscribe((user) => {
                // console.log({user});
                if (user) {
                    this.user = user;
                    this.cdr.detectChanges();
                }
            });
    }

    subscribePDF() {
        this.loading = true;
        this.cdr.detectChanges();
        this.usersService
            .notePrint(this.item.serie, this.item.numero, this.item.fecha)
            .pipe(detectChangesOnFinalize(this.cdr))
            .subscribe(
                (data) => {
                    if (!isUndefined(data)) {
                        this.item.URL_PDF = data;
                        this.loading = false;
                        if (!this.utilsService.downloadPDF(this.item.URL_PDF)) {
                            this.cdr.detectChanges();
                            this.translatesService
                                .get('error_popup_blocker_detected')
                                .pipe(detectChangesOnFinalize(this.cdr))
                                .subscribe((texto) => this.showToast(texto, false));
                        }
                    }
                },
                (error) => {
                    console.log('error');
                }
            );
    }

    clickDownloadDeliveryNote(ev) {
        ev.preventDefault();

        // console.log("clickDownloadDeliveryNote");

        // console.log("click item invoice donwload: ", item.URL_PDF);
        // window.open('http://www.axmag.com/download/pdfurl-guide.pdf', '_blank')

        this.subscribePDF();
        // this.item.URL_PDF ? this.utilsService.downloadPDF(this.item.URL_PDF) : '';
    }

    clickPrintDeliveryNote(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // console.log("click item invoice donwload: ", item.URL_PDF);
        // window.open('http://www.axmag.com/download/pdfurl-guide.pdf', '_blank')
        // window.open(item.URL_PDF, '_blank');

        this.utilsService.printPdf(this.item.URL_PDF);
    }

    clickNewIncidence(): void {
        // event.preventDefault();
        // event.stopPropagation();
        // if (!isEmptyObject(this.item)) {
        //     if (!isUndefined(this.item.numero)) {
        //         this.utilsService.openModalNewIncident('Albarán', this.item.numero.toString(), this.user);
        //         this.store.dispatch(new layoutsActions.CloseAsidePrimary());
        //     }
        // }
        this.modalsService.open('incidents-new', null, {
            typeIncident: 'Albaran',
            user: this.user,
            itemId: this.item.numero.toString()
        });
    }

    isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }

    showToast(msg: string, success: boolean) {
        const toastData: ToastData = ToastDataHelper.create({ type: success ? 'success' : 'error', text: msg });
        this.eventsService.broadcast('showToast', toastData);
    }
}
